import { useState } from 'react';
import { getColorVariantFromBackground } from '@klv/shared/utils/functions';
import AccordionMolecule from '@klv/molecules/accordion';
import MixedMedias from '@klv/molecules/mixed-medias';

import * as s from './styles';

import type { IAccordionRow } from '@klv/molecules/accordion/types';
import type { IMixedMedia } from '@klv/molecules/mixed-media/types';
import type { IAccordion } from './types';
import MixedMedia from '@klv/molecules/mixed-media';

const getMediaData = (rows: IAccordionRow[]): IMixedMedia[] => rows.map((row) => row?.mixedMedia || { mediaType: 'image' });

const mediaDataIsValid = (rows: IAccordionRow[]) => {
  const validRows = rows.filter((row) => (row?.mixedMedia?.mediaType === 'image' && row?.mixedMedia?.image !== null) || row?.mixedMedia?.video?.videoUrl !== null);
  return validRows.length === rows.length;
};

const Accordion = ({
  accordionItems,
  backgroundColor,
  eyebrow = '',
  headline = '',
  mediaOverride = false,
  isFaqsSection = false,
  mediaAlignment,
  mixedMedia,
  showMedia,
  subhead = '',
  academyVariant,
  ...rest
}: IAccordion) => {
  const [expandedRow, setExpandedRow] = useState(0);
  const showMediaInline = mediaAlignment === 'inline';
  const shouldShowMedia = !showMediaInline && (mediaOverride || (showMedia && mediaDataIsValid(accordionItems)));
  return (
    <s.StyledAccordion {...rest} $academyVariant={academyVariant} $variant={backgroundColor}>
      <s.StyledGrid>
        <s.GridText $mediaAlignment={mediaAlignment} $fullWidth={!shouldShowMedia}>
          {eyebrow && <s.StyledEyebrow content={eyebrow} />}
          {headline && <s.StyledHeadline variant="h3" forwardedAs="h2" colorVariant={getColorVariantFromBackground(backgroundColor)}>{headline}</s.StyledHeadline>}
          {subhead && <s.StyledSubhead dangerouslySetInnerHTML={{ __html: subhead }} variant={academyVariant ? 'h6' : 'paragraph2'} />}
          <AccordionMolecule
            expandedRow={expandedRow}
            isFaqsSection={isFaqsSection}
            setExpandedRow={setExpandedRow}
            rowHeadlineTag={headline ? 'h3' : 'h2'}
            rows={accordionItems}
            variant={backgroundColor}
            showMediaInline={showMediaInline}
          />
        </s.GridText>
        {shouldShowMedia ? (
          <s.GridMedia $mediaOverride={mediaOverride} $mediaAlignment={mediaAlignment}>
            {mediaOverride && mixedMedia ? (
              <MixedMedia mixedMedia={mixedMedia} />
            ) : (
              <MixedMedias
                currentIndex={expandedRow}
                mixedMediaData={getMediaData(accordionItems)}
              />
            )}
          </s.GridMedia>
        ) : null}
      </s.StyledGrid>
    </s.StyledAccordion>
  );
};

export default Accordion;
